module.exports = __webpack_public_path__ + "static/media/ccesen_home.fa3019b4.png";